import script from "./azureActiveDirectoryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./azureActiveDirectoryForm.vue?vue&type=script&setup=true&lang=ts"

import "./azureActiveDirectoryForm.vue?vue&type=style&index=0&id=33bac4f6&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33bac4f6"]])

export default __exports__